export default {"src":"/_next/static/media/chevron-up.c3f6f203.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};